import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddBackgroundImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 400 356",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".add-background-image-cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:28px;}" }) }),
		/* @__PURE__ */ _jsx("line", {
			className: "add-background-image-cls-1",
			x1: 18.75,
			y1: 180.18,
			x2: 182.56,
			y2: 18.94
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "add-background-image-cls-1",
			x1: 40.5,
			y1: 295.65,
			x2: 318.5,
			y2: 18.65
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "add-background-image-cls-1",
			d: "m167.5,295.65l-122.25.03c-14.01,0-25.37-11.36-25.37-25.37V48.02c0-14.01,11.36-25.37,25.37-25.37h272.38c14.01,0,25.37,11.36,25.37,25.37l.5,92.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "add-background-image-cls-1",
			d: "m375.22,331.35h-145.37c-3.33,0-6.03-2.7-6.03-6.03v-120.56c0-3.33,2.7-6.03,5.03-6.03h145.37c4.33,0,7.03,2.7,7.03,6.03v120.56c0,3.33-2.7,6.03-6.03,6.03Z"
		})
	]
});
export default SvgAddBackgroundImageIcon;
